import { HomeStateType, PayloadType } from "@/common/types";
import Types from "../types";

const homeInitialState: HomeStateType = {
  kitsPendingTesting: [],
  kitsPendingResultUpload: [],
  stats: {},
  kitsPendingSampleCollection: []
};

export const homeReducer = (
  state = homeInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_KITS_PENDING_TESTING:
      return {
        ...state,
        kitsPendingTesting: action.payload,
      };
    case Types.SET_KITS_PENDING_RESULT_UPLOAD:
      return {
        ...state,
        kitsPendingResultUpload: action.payload,
      };
    case Types.SET_HOME_PAGE_STATS:
      return {
        ...state,
        stats: action.payload,
      };
    case Types.SET_KITS_PENDING_SAMPLE_COLLECTION:
      return {
        ...state,
        kitsPendingSampleCollection: action.payload,
      };
    default:
      return state;
  }
};